/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_s3_115_51 as Componente_s3_115_51,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_o3_111_51(e) {
  let t = (0, ReactCompiler.c)(7),
    { filas: n, onAbrir: r } = e,
    i;
  if (t[0] !== n || t[1] !== r) {
    let e;
    (t[3] === r
      ? (e = t[4])
      : ((e = (e) => (
          <li
            key={e.id}
            children={
              <button
                type={`button`}
                onClick={() => r(e)}
                className={`${Bo} flex w-full flex-col gap-1 text-left active:scale-[0.99] ${e.activo ? `` : `opacity-60`}`}
                children={[
                  <span
                    className={`text-sm font-medium text-(--text-h)`}
                    children={e.apenom ?? e.dni ?? `VACANTE`}
                  />,
                  <span
                    className={`text-xs text-(--text)`}
                    children={
                      [e.cargoCorrecto, e.area].filter(Boolean).join(` · `) ||
                      `—`
                    }
                  />,
                  e.nombreJefe && (
                    <span
                      className={`text-xs text-(--text)`}
                      children={[`Jefe: `, e.nombreJefe]}
                    />
                  ),
                  e.alertas?.length > 0 && (
                    <Componente_s3_115_51 alertas={e.alertas} />
                  ),
                ]}
              />
            }
          />
        )),
        (t[3] = r),
        (t[4] = e)),
      (i = n.map(e)),
      (t[0] = n),
      (t[1] = r),
      (t[2] = i));
  } else i = t[2];
  let a;
  return (
    t[5] === i
      ? (a = t[6])
      : ((a = <ul className={`flex flex-col gap-2 sm:hidden`} children={i} />),
        (t[5] = i),
        (t[6] = a)),
    a
  );
}
